import React, { memo } from "react";

import type { MeterMove } from "./useMeterMove";

type RulebookMeterEffectsProps = {
  move: MeterMove | null;
  /** Keys the animations to the arriving snapshot so each new turn replays them. */
  snapshotId: string | undefined;
  meterId: string;
  testIdPrefix: string;
};

/** The change glow and the floating "+N" over a meter that just moved. */
const RulebookMeterEffects = ({ move, snapshotId, meterId, testIdPrefix }: RulebookMeterEffectsProps) =>
  move ? (
    <>
      <span
        key={`glow-${snapshotId}`}
        data-testid={`${testIdPrefix}-Glow-${meterId}`}
        className="rulebookHudGlow pointer-events-none absolute inset-x-[-6px] inset-y-[-5px] rounded-[10px]"
        style={move.glowStyle}
      />
      <span
        key={`float-${snapshotId}`}
        data-testid={`${testIdPrefix}-Float-${meterId}`}
        className="rulebookHudFloat pointer-events-none absolute -top-2 left-1/2 whitespace-nowrap text-[15px] font-extrabold opacity-0 [text-shadow:0_1px_6px_rgba(0,0,0,0.8)]"
        style={move.floatStyle}
      >
        {move.text}
      </span>
    </>
  ) : null;

export default memo(RulebookMeterEffects);
